import { useCallback, useEffect, useState } from "react";
import API from "../API";
import { PROCURING_ENTITY_REPORTS_ENDPOINT } from "../API/endpoints";

// Fetches and sets full report details whenever selectedReportID changes
export default function useSelectedReportDetails(selectedReportID, setSelectedReportDetails) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('idle'); // idle | loading | success | error

  const fetchDetails = useCallback(async () => {
    if (!selectedReportID) {
      setSelectedReportDetails(null);
      setLoading(false);
      return null;
    }
    setLoading(true);
    setError(null);
    setStatus('loading');
    try {
      const data = await API.get(`${PROCURING_ENTITY_REPORTS_ENDPOINT}/${selectedReportID}`);
      setSelectedReportDetails(data || null);
      setStatus('success');
      return data || null;
    } catch (e) {
      setSelectedReportDetails(null);
      setError(e);
      setStatus('error');
      return null;
    } finally {
      setLoading(false);
    }
  }, [selectedReportID, setSelectedReportDetails]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = fetchDetails();
      // swallow errors and cancellation; state updates already guarded in fetchDetails
      await p;
      if (cancelled) return;
    })();
    return () => { cancelled = true; };
  }, [fetchDetails]);

  return { loading, error, status, refetch: fetchDetails };
}
